import React, { useState } from "react";
import { EmailInputProps } from "../utils/Type";

export const EmailInput: React.FC<EmailInputProps> = ({ value, onChange }) => {
    const [input, setInput] = useState("");
    const emails = value.split(';').map(e => e.trim()).filter(Boolean);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === ';' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const trimmed = input.trim();
            if (trimmed && !emails.includes(trimmed)) {
                onChange([...emails, trimmed].join(';'));
                setInput("");
            }
        }
    };

    const removeEmail = (idx: number) => {
        onChange(emails.filter((_, i) => i !== idx).join(';'));
    };

    return (
        <div className="email-input-wrapper">
            {emails.map((email, i) => (
                <span className="email-chip" key={i}>
                    {email}
                    <span className="remove-btn" onClick={() => removeEmail(i)}>×</span>
                </span>
            ))}
            <input
                type="text"
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                className="email-input-field"
                placeholder="e-mail"
                autoComplete="off"
            />
        </div>
    );
};